<template>
  <DialogPopup
    class="theme__popup-dialog theme__popup-autoView"
    header-tag="h4"
    :show="showDialog"
    @close="showDialog = false"
    v-if="showDialog"
  >
    <template #header> Finding similar: </template>
    <template #body>
      <SimilarSentences
        ref="NotesSimilarSentencesResponses"
        :clientQuestionId="textAnalysisObject.selectedTextQuestion._id"
        :theme="matchingTheme"
        @addNewNote="addNewNote($event)"
        @selectThisResponse="$emit('selectThisResponse', $event)"
        :source="source"
      >
      </SimilarSentences>
    </template>
  </DialogPopup>
</template>

<script>
import DialogPopup from '@/components/UI/DialogPopup.vue';
import textAnalysisMixin from '../Mixins/textAnalysisMixin.js';
import SimilarSentences from './SimilarSentences.vue';

export default {
  name: 'SimilarSentencesPopup',
  components: {
    DialogPopup,
    SimilarSentences,
  },
  mixins: [textAnalysisMixin],
  props: {
    textAnalysisObject: {
      default: () => {},
      type: Object,
    },
    source: {
      default: () => 'NotesPopup',
      type: String,
    },
    sortedThemes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showDialog: false,
      matchingTheme: {},
    };
  },
  created() {},
  methods: {
    forceOpen(note) {
      if (note && note.themeId) {
        const foundTheme = this.sortedThemes.filter((theme) => theme._id == note.themeId);
        this.matchingTheme = foundTheme[0];

        setTimeout(() => {
          if (this.$refs['NotesSimilarSentencesResponses']) {
            this.$refs['NotesSimilarSentencesResponses'].findSimilar(note);
          }
        }, 100);

        this.showDialog = true;
      }
    },
    forceClose() {
      this.showDialog = false;
    },
    deepCloneObj(obj) {
      // deep clones an object using JSON stringify (data loss might occur)
      if (Array.isArray(obj)) {
        return obj.map((item) => JSON.parse(JSON.stringify(item)));
      } else if (typeof obj == 'object') {
        return JSON.parse(JSON.stringify(obj));
      }
    },
    async addNewNote(note_details) {
      const theme = note_details.theme;
      const themeId = theme._id?.$oid || theme._id;

      const sentence = note_details.sentence;

      const note = {
        content: sentence.text,
        length: sentence.end_idx - sentence.start_idx,
        responseId: sentence.response_id,
        row_index: sentence.row_index,
        source: {
          questionId: this.textAnalysisObject.selectedTextQuestion._id,
          responseText: '',
        },
        startIndex: sentence.start_idx,
        text: '',
      };

      this.$emit('updateTheme', {
        _id: themeId,
        notes_to_add: [note],
      });
    },
  },
  watch: {},
};
</script>

<style scoped>
.theme__popup-dialog {
  max-width: 60vw;
  width: calc(100% * 3);
  left: 10%;
}
</style>
